import { render, staticRenderFns } from "./GiftingGems.vue?vue&type=template&id=1c91071a&scoped=true"
import script from "./GiftingGems.vue?vue&type=script&lang=js"
export * from "./GiftingGems.vue?vue&type=script&lang=js"
import style0 from "./GiftingGems.vue?vue&type=style&index=0&id=1c91071a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c91071a",
  null
  
)

export default component.exports